exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.player[data-v-469efb08] {\n    /* position: absolute !important; */\n    width: 100%;\n    height: 60%;\n}\n.vjs-custom-skin[data-v-469efb08] {\n    height: 60% !important;\n}\n.vjs-custom-skin[data-v-469efb08] .video-js {\n    height: 60%;\n}\n.player-fit[data-v-469efb08] {\n    position: relative !important;\n    width: 100% !important;\n    height: auto !important;\n}\n\n", ""]);

// exports
